// extracted by mini-css-extract-plugin
export const animated = "NotificationTray__animated__sGNlG";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttons = "NotificationTray__buttons__pRST6";
export const desktopButtonWrapper = "NotificationTray__desktopButtonWrapper__MUtVh";
export const enter = "NotificationTray__enter__CqyLP";
export const enterActive = "NotificationTray__enterActive__GeRH3";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hidden = "NotificationTray__hidden__oHUXw";
export const icon = "NotificationTray__icon__pvB9c";
export const iconInRow = "NotificationTray__iconInRow__NOtFg";
export const item = "NotificationTray__item__B0zMM";
export const itemContent = "NotificationTray__itemContent__YcDmR";
export const itemInner = "NotificationTray__itemInner__6fIVG";
export const itemList = "NotificationTray__itemList__+k4WE";
export const itemText = "NotificationTray__itemText__-bIWw Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const leave = "NotificationTray__leave__6euLv";
export const leaveActive = "NotificationTray__leaveActive__G4ttw";
export const liveUpdateButtonWrapper = "NotificationTray__liveUpdateButtonWrapper__Y4SNP";
export const medium = "500";
export const notificationTray = "NotificationTray__notificationTray__NgYIw";
export const notificationTrayInner = "NotificationTray__notificationTrayInner__L066j";
export const notificationsBorderSize = "var(--notifications-border-size)";
export const notificationsExpandTime = "var(--notifications-expand-time)";
export const notificationsMaxHeightMobile = "var(--notifications-max-height-mobile)";
export const positionRelative = "NotificationTray__positionRelative__RU8fD";
export const regular = "400";
export const sans = "'sans'";
export const scrollable = "NotificationTray__scrollable__igOX8";
export const semibold = "600";
export const serif = "'serif'";
export const settingsMode = "NotificationTray__settingsMode__nAzVX";
export const sidebarMode = "NotificationTray__sidebarMode__rBdqB";
export const visible = "NotificationTray__visible__zilDm";
export const withIcon = "NotificationTray__withIcon__ooA17";